export default "__VITE_ASSET__lFAXrD$f__"